import React, { useState, useRef, useEffect } from "react";
import { usePairData, pairId } from "../hooks/usePairData";
import PairSpreadCard from "./PairSpreadCard";
import AddPairModal from "./AddPairModal";
import SpreadScreener from "./SpreadScreener";

const RANGES = [["6mo", "6개월"], ["1y", "1년"], ["3y", "3년"], ["5y", "5년"]];

// 룩백 토글 (헤더용/플로팅용 공용). vertical=true면 세로 스택.
function RangeToggle({ range, setRange, vertical }) {
  return (
    <div style={{ display: "flex", flexDirection: vertical ? "column" : "row", border: "1px solid #e2e2e2", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
      {RANGES.map(([v, lab]) => (
        <button key={v} onClick={() => setRange(v)}
          style={{
            padding: vertical ? "9px 12px" : "6px 12px", border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700,
            background: range === v ? "#1a1a2e" : "#fff", color: range === v ? "#fff" : "#888",
          }}>{lab}</button>
      ))}
    </div>
  );
}

export default function PairSpreadBook({ pairs, holdings, onAddPair, onDeletePair }) {
  const [range, setRange] = useState("3y");
  const [showAdd, setShowAdd] = useState(false);
  const [showFloat, setShowFloat] = useState(false);
  const { data, loading } = usePairData(pairs, range);

  const sectionRef = useRef(null);
  const headerRef = useRef(null);

  // 헤더가 화면 위로 사라지고, 섹션 안에 있을 때만 플로팅 토글 표시
  useEffect(() => {
    const onScroll = () => {
      if (!sectionRef.current || !headerRef.current) return;
      const h = headerRef.current.getBoundingClientRect();
      const s = sectionRef.current.getBoundingClientRect();
      setShowFloat(h.bottom < 8 && s.bottom > 220 && pairs.length > 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); window.removeEventListener("resize", onScroll); };
  }, [pairs.length]);

  return (
    <div ref={sectionRef} style={{ marginTop: 28 }}>
      {/* 헤더 */}
      <div ref={headerRef} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
        <h2 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>
          📈 페어 스프레드 차트북 <span style={{ fontSize: 13, color: "#aaa", fontWeight: 500 }}>({pairs.length})</span>
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {loading && <span style={{ fontSize: 12, color: "#aaa" }}>불러오는 중…</span>}
          <RangeToggle range={range} setRange={setRange} />
          <button onClick={() => setShowAdd(true)}
            style={{ padding: "7px 14px", borderRadius: 8, border: "none", background: "#1f3a93", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
            + 페어 추가
          </button>
        </div>
      </div>

      {pairs.length === 0 ? (
        <div style={{ padding: 40, textAlign: "center", color: "#aaa", background: "#fafafa", borderRadius: 12, border: "1px dashed #ddd" }}>
          아직 페어가 없습니다. <b>+ 페어 추가</b>로 롱/숏 페어를 등록하세요.
        </div>
      ) : (
        pairs.map(p => (
          <div key={pairId(p)} id={`pair-${pairId(p)}`}>
            <PairSpreadCard pair={p} result={data[pairId(p)]} onDelete={onDeletePair} />
          </div>
        ))
      )}

      {/* 스프레드 스크리너 (엑셀 통계량 top10 롱/숏) */}
      <SpreadScreener existingPairs={pairs} onAddPair={onAddPair} />

      {/* 스크롤 시 우측 따라오는 플로팅 토글 */}
      {showFloat && (
        <div style={{ position: "fixed", right: 14, top: "42%", transform: "translateY(-50%)", zIndex: 900, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 9, color: "#aaa", fontWeight: 700 }}>룩백</span>
          <RangeToggle range={range} setRange={setRange} vertical />
        </div>
      )}

      {showAdd && (
        <AddPairModal holdings={holdings} onAdd={onAddPair} onClose={() => setShowAdd(false)} />
      )}
    </div>
  );
}
